import config from '@/Constants';
import { UnexpectedError } from '@/modules/shared/domain/errors';
import { AxiosHelper } from '@/modules/shared/infra/protocols/http';
import { Favorite } from '@/modules/shared/domain/interfaces';

interface BatchTaskSharedParams {
  formulary_id?: string;
  date_start?: number;
  date_end?: number;
  active: boolean;
  description?: string;
  user_profile_id?: string;
  origin_id?: string;
  origin_type?: string;
  batch_tags?: Array<{ id: string }>;
}

interface BatchTaskUniqueParams {
  name: string;
  member_id?: string;
  local_id?: string;
}

async function createTasksBatchService(
  shared_params: BatchTaskSharedParams,
  tasks: BatchTaskUniqueParams[],
): Promise<boolean> {
  const { statusCode } = await AxiosHelper.post({
    url: `${config.TASKS_URL}/create_batch`,
    body: { shared_params, tasks },
  });
  if (statusCode < 200 || statusCode > 300) {
    throw new UnexpectedError();
  }
  return true;
}

function buildBatchPayload(
  favorite: Favorite,
  count: number,
): { shared_params: BatchTaskSharedParams; tasks: BatchTaskUniqueParams[] } {
  const values = favorite.values as any;
  const formularyObj = Array.isArray(values.formulary) ? values.formulary[0] : values.formulary;
  const localObj = Array.isArray(values.local) ? values.local[0] : values.local;

  const shared_params: BatchTaskSharedParams = {
    formulary_id: formularyObj?.value,
    date_start: values.date_start ?? new Date().getTime(),
    date_end: values.date_end,
    active: values.active ?? true,
    description: values.description,
    user_profile_id: values.user_profile_id,
    origin_id:
      typeof values.origin_id === 'string' ? values.origin_id : values.origin_id?.value,
    origin_type:
      typeof values.origin_type === 'string' ? values.origin_type : values.origin_type?.value,
    batch_tags: (Array.isArray(values.tags) ? values.tags : []).map((t: any) => ({
      id: t.value || t.id,
    })),
  };

  const uniqueTask: BatchTaskUniqueParams = {
    name: values.name || favorite.name,
    member_id: values.member?.value,
    local_id: localObj?.value,
  };

  return {
    shared_params,
    tasks: Array.from({ length: count }, () => uniqueTask),
  };
}

export { createTasksBatchService, buildBatchPayload };
